//@ts-check

import React from "react"
import { useTranslation } from "react-i18next"
const CONSTS = require("shared/consts")
import store, { qs } from "../store"
export default function StepsList({ stepIndex = undefined }) {
  function onChange(newSteps) {
    store.steps = newSteps
    store.selectedStep = newSteps.length - 1
    store.updateSimulationMetadataProperty(
      "numOfSteps",
      newSteps.length,
      store.currentStoryId,
    )
    store.updateStore()
  }

  const { t } = useTranslation()

  /**
   * @param step {import("../../../backend/interfaces").Step}
   */
  function createNewStep(step) {
    step.uid = new Date().valueOf()
    var newSteps = store.steps.concat()
    if (stepIndex) {
      newSteps.splice(stepIndex, 0, step)
    } else {
      newSteps.push(step)
    }
    onChange(newSteps)
  }

  return (
    <div
      // css={`
      //   display: flex;
      //   height: 100%;
      //   flex-direction: column;
      // `}
      css={`
        padding-left: 5px;
        padding-right: 5px;
        border-left: 1px solid #eee;
        border-bottom: 1px solid #eee;
      `}
    >
      <div>
        {!store.isReadOnly && (
          <>
            <div
              css={`
                /* text-align: center; */
                font-size: 0.75rem;
                color: #2e2e38;

                display: inline-block;
                margin-bottom: 10px;
                font-weight: 300;
                font-weight: bold;
              `}
            >
              New Step
            </div>
            <div>
              {[
                {
                  onClick: () => {
                    var to
                    var from = "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
                    // Creating default
                    // find the latest deployed address of smart contract
                    for (var i = store.steps.length - 1; i >= 0; i--) {
                      if(store.steps[i].type === CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT){
                        to = '0x000000000000000000000000000000000000000' + (i+1)
                      } 
                      // var to =
                      //   store.steps[i].deployedAddress || store.steps[i].to
                      if (to) break
                    }
                    var manualBlock =
                      store.steps[store.steps.length - 1]?.manualBlock
                    var blockNumber =
                      store.steps[store.steps.length - 1]?.blockNumber
                    var blockTimestamp =
                      store.steps[store.steps.length - 1]?.blockTimestamp

                    for (var i = store.steps.length - 1; i >= 0; i--) {
                      let address = store.steps[i].from
                      if (address) {
                        from = address
                        break
                      }
                    }
                    createNewStep({
                      type: CONSTS.STEP_TYPES.ENCODE_TRANSACTION,
                      from,
                      to,
                      value: "0",
                      execute: "yes",
                      blockNumber,
                      blockTimestamp,
                      manualBlock,
                      description: "",
                      should_pass: true,
                      has_expected_output: false,
                      expected_output: [],
                      has_expected_events: false,
                      pass_if_other_event_emitted: false,
                      expected_events: [],
                      skip: false,
                    })
                  },
                  //@ts-ignore
                  // icon: require("./icons/encode.png"),
                  title: CONSTS.getStepNameByType(
                    CONSTS.STEP_TYPES.ENCODE_TRANSACTION,
                    store.isDryRun,
                  ),
                },
                {
                  onClick: () => {
                    var i = store.steps.filter((x) =>
                      x?.contractName?.match?.(/Unnamed contract/),
                    )
                    var addtoName = ""
                    if (i.length > 0) {
                      addtoName = " " + i.length
                    }
                    createNewStep({
                      type: CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT,
                      files: [
                        {
                          path: "main.sol",
                          content: `
                            pragma solidity "0.7.1";
                            contract ExampleContract {
                              function exampleFunction(string memory p1) public {
                              }
                            }
                        `,
                        },
                      ],
                      contractName: "Unnamed contract" + addtoName,
                      abiLoadingStatus: "ready",
                      alias: "Unnamed contract" + addtoName,
                      compilerVersion: "v0.7.1+commit.f4a555be",
                      mainContract: "ExampleContract",
                      deployedAddress: "0x" + genHexString(40),
                      mainFile: "main.sol",
                      compilerSettings: {
                        optimizer: {
                          enabled: false,
                          runs: 200,
                        },
                        viaIR: false,
                      },
                      nonce: 0,
                      bytecode:
                        "0x608060405234801561001057600080fd5b5061011b806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063bc2d73ba14602d575b600080fd5b60e060048036036020811015604157600080fd5b8101908080359060200190640100000000811115605d57600080fd5b820183602082011115606e57600080fd5b80359060200191846001830284011164010000000083111715608f57600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f82011690508083019250505050505050919291929050505060e2565b005b5056fea264697066735822122095cbcf7a73a4c7322e9dff8fceb62ece74c74fab2f336a036220ddd945e5071064736f6c63430007010033",
                      data: "0x608060405234801561001057600080fd5b5061011b806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063bc2d73ba14602d575b600080fd5b60e060048036036020811015604157600080fd5b8101908080359060200190640100000000811115605d57600080fd5b820183602082011115606e57600080fd5b80359060200191846001830284011164010000000083111715608f57600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f82011690508083019250505050505050919291929050505060e2565b005b5056fea264697066735822122055d99c6512b273179207626e2b538edc613b9b723b9baac4ef3cb66c2b9b97cb64736f6c63430007010033",
                      value: "0",
                      deploy: "yes",
                      abi: [
                        {
                          inputs: [
                            {
                              internalType: "string",
                              name: "p1",
                              type: "string",
                            },
                          ],
                          name: "exampleFunction",
                          outputs: [],
                          stateMutability: "nonpayable",
                          type: "function",
                          signature: "0xbc2d73ba",
                        },
                      ],
                      from: "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                      deployAlias:
                        "Address of Unnamed contract" +
                        addtoName +
                        " smart contract",
                      description: "",
                      should_pass: true,
                      skip: false,
                      has_expected_events: false,
                      pass_if_other_event_emitted: false,
                      expected_events: [],
                      using_review_files: qs().review_id ? true : false,
                    })
                  },
                  //@ts-ignore
                  // icon: require("./icons/define.png"),
                  title: CONSTS.getStepNameByType(
                    CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT,
                    store.isDryRun,
                  ),
                },
                {
                  onClick: () => {
                    //@ts-ignore
                    createNewStep({
                      type: CONSTS.STEP_TYPES.CHECk_BALANCE,
                      to: "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                      description: "",
                      should_pass: true,
                      has_expected_output: false,
                      expected_output: [],
                      skip: false,
                    })
                  },
                  //@ts-ignore
                  title: CONSTS.getStepNameByType(
                    CONSTS.STEP_TYPES.CHECk_BALANCE,
                    store.isDryRun,
                  ),
                },
              ].map((item) => {
                // if (!item.title) return <br />
                if (!item.onClick)
                  return (
                    <div>
                      <b>{item.title}</b>
                    </div>
                  )
                return (
                  <div
                    key={item.title}
                    css={`
                      /* text-align: center; */
                      font-size: 0.75rem;
                      color: #2e2e38;
                      cursor: pointer;
                      border: ${item.isCancel
                        ? "none!important"
                        : "1px solid #EAEAF2;"};
                      border-radius: 50px;
                      box-shadow: 2px 2px 0px 0px #f5f5f5;
                      display: inline-block;
                      padding: 8px 16px;
                      font-weight: 300;
                      margin-right: 5px;
                      margin-bottom: 10px;
                      background: ${item.isCancel
                        ? "none!important"
                        : "#e7e7ea"};
                      :hover {
                        background: #ddd;
                      }
                    `}
                    onClick={() => {
                      item.onClick()
                    }}
                  >
                    {/* <img css={`
                  width:12px;
                  height:auto;
                  vertical-align:middle;
                `} src={item.icon} />&nbsp; */}
                    {item.title}
                  </div>
                )
              })}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function genHexString(len) {
  console.log('genHex')
  let output = ""
  for (let i = 0; i < len; ++i) {
    output += Math.floor(Math.random() * 16).toString(16)
  }
  return output
}
